import React from 'react';
import PageShell from '@/components/PageShell';
import FaqSection, { faqs } from '@/components/sections/FaqSection';

const Faq = () => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.question,
      acceptedAnswer: { '@type': 'Answer', text: f.answer },
    })),
  };

  return (
    <PageShell
      title="Vapour Blasting FAQ | Cost, Turnaround & Aftercare NZ"
      description="Common questions about vapour blasting in Christchurch — cost, turnaround, what we clean, aftercare and whether it damages parts."
      canonicalPath="/faq"
      crumbs={[{ name: 'FAQ', path: '/faq' }]}
      jsonLd={[faqSchema]}
    >
      <h1 className="sr-only">Vapour Blasting FAQ — Christchurch</h1>
      <FaqSection />
    </PageShell>
  );
};

export default Faq;
